// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 2px 10px; */
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  min-width: 100vw;
  top: 0;
  height: 90px;
  z-index: 1000;
  overflow-x: hidden;
}

.rajdhani-bold {
  font-family: "Rajdhani", sans-serif;
  text-decoration: none;
  font-weight: 700;
  color: #66a53d;
  font-style: normal;
  font-size: 1.5em;
  margin-right: 10px;
  margin-bottom: 5px;
}

.header-logo {
  margin-left: 6em;
  height: 50px;
  width: 175px;
}

.logo-container {
  display: flex;
  align-items: center;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  margin-bottom: 5px;
}

.nav-links-wrapper {
  margin-left: 5em;
  margin-right: 1em;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  flex-direction: row;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 50px;
  margin: 0;
  padding: 0;
}

.nav-items {
  position: relative;
}

.nav-items li {
  margin: 0;
  padding: 0;
}

.nav-links a {
  text-decoration: none;
  color: #404040;
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 1em;
  align-items: center;
}

.nav-links a:hover {
  font-family: "Fivo Sans Medium", sans-serif;
  color: #9e1c20;
  transition-duration: 0.5s;
}
.auth-buttons {
  margin: 0 2em;
  display: flex;
  gap: 2.5em;
}

.greeting {
  height: min-content;
  font-family: "Fivo Sans Bold", sans-serif;
  font-size: 1.1em;
  color: #c1272d;
  margin-right: -1.2em;
  margin-left: 1.2em;
  margin-top: 1.3em;
}

.sign-out-button {
  padding: 0.7em 1.625em;
  width: 10em;
  font-size: 1em;
  background-color: #c1272d;
  color: white;
  border: 2px solid #c1272d;
  border-radius: 1.875em;
  cursor: pointer;
  text-transform: capitalize;
  font-family: "Fivo Sans Medium", sans-serif;
}
.login-button {
  width: 10em;
  border: 2px solid #c1272d;
  border-radius: 1.875em;
  padding: 0.7em 1.625em;
  color: #c1272d;
  background: none;
  text-decoration: none;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 0.7em;
  text-align: center;
  text-transform: capitalize;
  display: inline-block;
  transition-duration: 0.4s;
}
.login-button:hover {
  color: white;
  background: #c1272d;
}
.create-account-button {
  width: 12em;
  border: 2px solid #c1272d;
  border-radius: 1.875em;
  padding: 0.7em 1.625em;
  color: white;
  background: #c1272d;
  font-size: 0.7em;
  text-decoration: none;
  font-family: "Fivo Sans Medium", sans-serif;
  text-align: center;
  text-transform: capitalize;
  display: inline-block;
  transition-duration: 0.4s;
}
.create-account-button:hover {
  background: #d23038;
}
.hamburger-menu {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  z-index: 1001;
}

/* Ensure the hamburger menu is always visible */
.hamburger-menu span {
  display: block;
  width: 25px;
  height: 3px;
  background-color: #333;
  margin: 3.5px 0;
  transition: all 0.3s ease;
}
.hamburger-menu:hover {
  background-color: white;
}
.hamburger-menu.open span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-menu.open span:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.open span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}
/* Sidebar styles */
.sidebar {
  display: none;
  flex-direction: column;
  background: rgba(37, 82, 149, 1);
  position: fixed;
  top: 0;
  left: 0;
  width: max-content;
  height: 100%;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding-top: 60px;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
}

.sidebar.open {
  transform: translateX(0);
}

.sidebar .nav-links {
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  list-style: none;
}
::marker {
  color: #ffffff;
}
.sidebar .nav-links a {
  color: #ffffff;
  font-family: "Fivo Sans Medium", sans-serif;
  font-weight: bold;
  font-size: 1.2em;
  text-decoration: none;
  text-align: center;
}
.sidebar .nav-links a:hover {
  color: #d23038;
}
.sidebar .auth-buttons {
  flex-direction: column;
  gap: 1.25em;
  position: absolute;
  bottom: 5em;
  width: 100%;
  margin: 0 0;
  padding: 0em;
  justify-content: center;
  align-items: center;
}

.sidebar .login-button {
  color: #c1272d;
  background: #ffffff;
  width: 70%;
  border: 2px solid #c1272d;
}
.sidebar .login-button:hover {
  color: #ffffff;
  background: #d23038;
  width: 70%;
  border: 2px solid #d23038;
}
.sidebar .create-account-button {
  color: #ffffff;
  background: #c1272d;
  width: 70%;
  border: 2px solid #c1272d;
}
.sidebar .create-account-button:hover {
  color: #ffffff;
  background: #d23038;
  width: 70%;
  border: 2px solid #d23038;
}
/* Responsive styles */
@media (max-width: 1300px) {
  .nav-links-wrapper {
    display: none;
  }

  .hamburger-menu {
    display: block;
  }
  .header-logo {
    margin-left: 0em;
    height: 50px;
    width: 175px;
  }

  .sidebar {
    display: flex;
  }
  .sidebar .greeting {
    margin-right: 0em;
  }
  .sidebar .nav-links {
    align-items: center;
  }
}

@media (min-width: 1301px) {
  .hamburger-menu {
    display: none;
  }

  .sidebar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Header/Header.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,4CAA4C;EAC5C,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;AACA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* General styles */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* padding: 2px 10px; */\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  min-width: 100vw;\n  top: 0;\n  height: 90px;\n  z-index: 1000;\n  overflow-x: hidden;\n}\n\n.rajdhani-bold {\n  font-family: \"Rajdhani\", sans-serif;\n  text-decoration: none;\n  font-weight: 700;\n  color: #66a53d;\n  font-style: normal;\n  font-size: 1.5em;\n  margin-right: 10px;\n  margin-bottom: 5px;\n}\n\n.header-logo {\n  margin-left: 6em;\n  height: 50px;\n  width: 175px;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n  margin-bottom: 5px;\n}\n\n.nav-links-wrapper {\n  margin-left: 5em;\n  margin-right: 1em;\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: baseline;\n  flex-direction: row;\n}\n\n.nav-links {\n  list-style: none;\n  display: flex;\n  gap: 50px;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-items {\n  position: relative;\n}\n\n.nav-items li {\n  margin: 0;\n  padding: 0;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: #404040;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 1em;\n  align-items: center;\n}\n\n.nav-links a:hover {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  color: #9e1c20;\n  transition-duration: 0.5s;\n}\n.auth-buttons {\n  margin: 0 2em;\n  display: flex;\n  gap: 2.5em;\n}\n\n.greeting {\n  height: min-content;\n  font-family: \"Fivo Sans Bold\", sans-serif;\n  font-size: 1.1em;\n  color: #c1272d;\n  margin-right: -1.2em;\n  margin-left: 1.2em;\n  margin-top: 1.3em;\n}\n\n.sign-out-button {\n  padding: 0.7em 1.625em;\n  width: 10em;\n  font-size: 1em;\n  background-color: #c1272d;\n  color: white;\n  border: 2px solid #c1272d;\n  border-radius: 1.875em;\n  cursor: pointer;\n  text-transform: capitalize;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n.login-button {\n  width: 10em;\n  border: 2px solid #c1272d;\n  border-radius: 1.875em;\n  padding: 0.7em 1.625em;\n  color: #c1272d;\n  background: none;\n  text-decoration: none;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 0.7em;\n  text-align: center;\n  text-transform: capitalize;\n  display: inline-block;\n  transition-duration: 0.4s;\n}\n.login-button:hover {\n  color: white;\n  background: #c1272d;\n}\n.create-account-button {\n  width: 12em;\n  border: 2px solid #c1272d;\n  border-radius: 1.875em;\n  padding: 0.7em 1.625em;\n  color: white;\n  background: #c1272d;\n  font-size: 0.7em;\n  text-decoration: none;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  text-align: center;\n  text-transform: capitalize;\n  display: inline-block;\n  transition-duration: 0.4s;\n}\n.create-account-button:hover {\n  background: #d23038;\n}\n.hamburger-menu {\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  z-index: 1001;\n}\n\n/* Ensure the hamburger menu is always visible */\n.hamburger-menu span {\n  display: block;\n  width: 25px;\n  height: 3px;\n  background-color: #333;\n  margin: 3.5px 0;\n  transition: all 0.3s ease;\n}\n.hamburger-menu:hover {\n  background-color: white;\n}\n.hamburger-menu.open span:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n\n.hamburger-menu.open span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-menu.open span:nth-child(3) {\n  transform: rotate(-45deg) translate(5px, -5px);\n}\n/* Sidebar styles */\n.sidebar {\n  display: none;\n  flex-direction: column;\n  background: rgba(37, 82, 149, 1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: max-content;\n  height: 100%;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  padding-top: 60px;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n}\n\n.sidebar.open {\n  transform: translateX(0);\n}\n\n.sidebar .nav-links {\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  list-style: none;\n}\n::marker {\n  color: #ffffff;\n}\n.sidebar .nav-links a {\n  color: #ffffff;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-weight: bold;\n  font-size: 1.2em;\n  text-decoration: none;\n  text-align: center;\n}\n.sidebar .nav-links a:hover {\n  color: #d23038;\n}\n.sidebar .auth-buttons {\n  flex-direction: column;\n  gap: 1.25em;\n  position: absolute;\n  bottom: 5em;\n  width: 100%;\n  margin: 0 0;\n  padding: 0em;\n  justify-content: center;\n  align-items: center;\n}\n\n.sidebar .login-button {\n  color: #c1272d;\n  background: #ffffff;\n  width: 70%;\n  border: 2px solid #c1272d;\n}\n.sidebar .login-button:hover {\n  color: #ffffff;\n  background: #d23038;\n  width: 70%;\n  border: 2px solid #d23038;\n}\n.sidebar .create-account-button {\n  color: #ffffff;\n  background: #c1272d;\n  width: 70%;\n  border: 2px solid #c1272d;\n}\n.sidebar .create-account-button:hover {\n  color: #ffffff;\n  background: #d23038;\n  width: 70%;\n  border: 2px solid #d23038;\n}\n/* Responsive styles */\n@media (max-width: 1300px) {\n  .nav-links-wrapper {\n    display: none;\n  }\n\n  .hamburger-menu {\n    display: block;\n  }\n  .header-logo {\n    margin-left: 0em;\n    height: 50px;\n    width: 175px;\n  }\n\n  .sidebar {\n    display: flex;\n  }\n  .sidebar .greeting {\n    margin-right: 0em;\n  }\n  .sidebar .nav-links {\n    align-items: center;\n  }\n}\n\n@media (min-width: 1301px) {\n  .hamburger-menu {\n    display: none;\n  }\n\n  .sidebar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
